import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import HealthCenterStaffBody from "components/ClinicalManagement/HealthCenters/Details/HealthCenterStaff/HealthCenterStaffBody";

const HealthCenterStaff = () => {
  useEffect(() => {
    document.title = "Health Center Staff";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <HealthCenterStaffBody />
    </main>
  );
};

export default HealthCenterStaff;
